<template>
  <div class="areas">
    <el-tabs
      type="border-card"
      class="fullHeight">
        <el-tab-pane :label="$t('Estado de Inventarios')">
          <InventoriesStatusTab />
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import InventoriesStatusTab from '@/pages/admin/reports/_InventoriesStatusTab.vue';

export default {
  components: {
    InventoriesStatusTab,
  },
};
</script>

<style scoped>
</style>
